module.exports = __webpack_public_path__ + "static/media/av_1_on.8b2d054b.png";